/**
 * Created by piotr.pozniak@thebeaverhead.com on 05/08/2024
 *
 * @param {Object} job
 * @param {boolean=false} asPercentage
 * @param {boolean=false} showETA
 */
import React, { useEffect, useMemo, useState } from "react";
import { durationToString } from "../../tools";
import { syncDurationInSeconds } from "../../helpers/sync";
import styles from "./QueueJobsPage.module.scss";

const QueueJobToDuration = ({ job, asPercentage = false, showETA = false }) => {
  const [lastUpdated, setLastUpdated] = useState(new Date());

  const isSyncing = useMemo(() => {
    return job.fetched && !job.failed && !job.completed;
  }, [job]);

  const durationInSeconds = useMemo(() => {
    return syncDurationInSeconds(job);
  }, [job, lastUpdated]);

  useEffect(() => {
    if (isSyncing) {
      const interval = setInterval(() => {
        setLastUpdated(new Date());
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [isSyncing, durationInSeconds]);

  if (!durationInSeconds) {
    return <span className={styles.durationText}>&mdash;</span>;
  }

  // format duration to human readable string using Date objects
  const lastDuration = job.data.last_duration + 30;

  let timeRemaining = null;

  if (showETA) {
    timeRemaining = lastDuration - durationInSeconds;
  }

  const percentageProgress = Math.round(
    (durationInSeconds * 100) / lastDuration
  );

  const output =
    asPercentage && percentageProgress <= 100
      ? `${percentageProgress}%`
      : durationToString(durationInSeconds);

  return (
    <span className={styles.durationText}>
      {output}{" "}
      {showETA && timeRemaining >= 0
        ? ` (ETA ${durationToString(timeRemaining)})`
        : null}
    </span>
  );
};

export default QueueJobToDuration;
